import { Box, LinearProgress, Typography, useTheme } from "@mui/material";
import { type FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const SaveProgressIndicator: FC<{ progress: number | null }> = ({ progress }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const progressText = useMemo(() => {
    if (progress === null) return "";

    if (progress <= 25) {
      return t("Preparing to save...");
    } else if (progress <= 50) {
      return t("Optimizing...");
    } else if (progress <= 75) {
      return t("Saving...");
    } else {
      return t("Finalizing save");
    }
  }, [progress, t]);

  return (
    progress && (
      <Box
        sx={{
          p: 1,
          px: 2,
          bgcolor: "background.contrast",
          borderRadius: `${theme.shape.borderRadius}px`,
          width: 180,
        }}
      >
        <Typography lineHeight={2.2} variant="body2">
          {progressText}
        </Typography>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    )
  );
};
